import { styled } from "@mui/material/styles";
import { useEffect, useRef, useState } from "preact/hooks";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { formatDate } from "date-fns";
import { useMediaQuery } from "usehooks-ts";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import searchingGif from "../assets/loading.gif";
import InfiniteScroll from "react-infinite-scroll-component";

const RecentlyPlayedWrapper = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .recentlyPlayedListWrapper {
    max-height: ${(props) => (props.fullPage ? "75vh" : "40vh")};
    width: 98%;
    overflow-y: auto;
    padding-right: 1rem;
  }
  .songIcon {
    height: 48px;
    width: 48px;
    border-radius: 12px;
    margin-right: 10px;
  }
  .viewAll {
    position: absolute;
    width: 96px;
    min-height: 32px;
    top: 20px;
    right: 0;
    cursor: pointer;
    height: fit-content;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 44px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #1c1c1e;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .songsListContainer {
    display: flex;
    flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    text-align: left;
    width: 98%;
    .album-row {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .details-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-right: 0.25rem;
      gap: 1.4rem;
      box-sizing: border-box;
      padding-left: 0;
      width: ${(props) => (props.isMobile ? "100%" : "auto")};

      .amount {
        display: flex;
        align-items: center;
        color: white;
        min-wdth: 140px;
        font-size: 16px;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .songName,
    .songArtist {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* Adjust this value to control how many lines to display */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .songsListContainer.active {
    background-color: #2a2a2a;
    margin-top: 10px;
    border-radius: 12px;
    padding: 0.5rem;
    width: 96%;
  }
  .songName {
    white-space: nowrap !important;
  }
  .songName.active {
    @media only screen and (max-width: 724px) {
      white-space: ${(props) =>
        props.expanded ? "normal !important" : "nowrap !important"};
    }
  }
  .songArtist {
    white-space: nowrap !important;
  }
  .songArtist.active {
    @media only screen and (max-width: 724px) {
      white-space: ${(props) =>
        props.expanded ? "normal !important" : "nowrap !important"};
    }
  }

  .indexText {
    color: #c4c4c4;
    font-size: 14px;
    line-height: 18px;
    margin-right: 10px;
  }

  .expandToggle {
    display: flex;
    flex-direction: column;
    align-items: center;
    .amount {
      display: flex;
      align-items: center;
      color: white;
      min-wdth: 140px;
      font-size: 16px;
    }
  }

  .loadingContainer {
    margin: 2rem 0;
    color: #c4c4c4;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

// function truncateText(text, maxLength) {
//   return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
// }

function RecentRequest({ isPlayedScreen, recentlyPlayedSongs, ...props }) {
  const [expandedItems, setExpandedItems] = useState([]);
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const [showAction, setShowAction] = useState(true);

  useEffect(() => {
    if (!isMobile) {
      setExpandedItems([]); // Collapse if not on mobile screen size
    }
  }, [isMobile]);

  const {
    playlistSongsoffset,
    setPlaylistSongsoffset,
    requestAnalyticsData,
    playlistEndReached,
    fullPage = true,
  } = props;

  const requestsScrollRef = useRef();

  useEffect(() => {
    if (playlistSongsoffset == 0 && requestsScrollRef.current) {
      requestsScrollRef.current.scrollTop = 0;
    }
  }, [playlistSongsoffset]);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 1 <= e.target.clientHeight;
    if (bottom) {
      requestAnalyticsData(playlistSongsoffset + 1);
      setPlaylistSongsoffset(playlistSongsoffset + 1);
    }
  };

  const fetchNextData = (offset) => {
    requestAnalyticsData(offset + 1);
    setPlaylistSongsoffset(offset + 1);
  };

  return (
    <RecentlyPlayedWrapper
      fullPage={fullPage}
      isMobile={isMobile}
      expanded={expandedItems.length > 0}
      style={isPlayedScreen ? { width: "100%" } : { minWidth: "495px" }}
    >
      <div
        id="recentSongsList"
        className={isPlayedScreen ? "recentlyPlayedListWrapper" : ""}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
        // onScroll={handleScroll}
      >
        <InfiniteScroll
          scrollableTarget="recentSongsList"
          dataLength={recentlyPlayedSongs.length} //This is important field to render the next data
          next={() => fetchNextData(playlistSongsoffset)}
          hasMore={isPlayedScreen && !playlistEndReached}
          loader={
            playlistSongsoffset > 0 ? (
              <div className="loadingContainer">
                <img
                  src={searchingGif}
                  alt="Searching Gif"
                  style={{ width: "36px", height: "10px" }}
                />
              </div>
            ) : null
          }
          endMessage={
            <p
              style={{
                textAlign: "center",
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              <b>Yay! You have seen it all</b>
            </p>
          }
        >
          {recentlyPlayedSongs.map((request, index) =>
            isPlayedScreen || (!isPlayedScreen && index < 3) ? (
              <div
                className={`songsListContainer ${
                  expandedItems.includes(`${request.id}-${index}`)
                    ? "active"
                    : ""
                }`}
                key={`${request.id}-${index}`}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div className="album-row">
                    {isPlayedScreen && (
                      <div className="indexText">{index + 1}</div>
                    )}
                    <div>
                      <img
                        src={request.track.logo}
                        alt=""
                        className="songIcon"
                      />
                    </div>
                    <div>
                      <div
                        className={`songName ${
                          expandedItems.includes(`${request.id}-${index}`)
                            ? "active"
                            : ""
                        }`}
                        style={
                          !isPlayedScreen && {
                            maxWidth: "25vw",
                            display: "-webkit-box",
                            "-webkit-box-orient": "vertical",
                            "-webkit-line-clamp": 2,
                          }
                        }
                      >
                        {request.track.title}
                        {/* {truncateText(request.track.title, 26)} */}
                      </div>
                      <div
                        className={`songArtist ${
                          expandedItems.includes(`${request.id}-${index}`)
                            ? "active"
                            : ""
                        }`}
                        style={
                          !isPlayedScreen && {
                            maxWidth: "26vw",
                            display: "-webkit-box",
                            "-webkit-box-orient": "vertical",
                            "-webkit-line-clamp": 2,
                          }
                        }
                      >
                        {request.track.album} | {request.track.artist}
                        {/* {truncateText(
                          `${request.track.album} | ${request.track.artist}`,
                          30
                        )} */}
                      </div>
                    </div>
                  </div>
                  {isMobile && (
                    <div
                      className="expandToggle"
                      onClick={() =>
                        setExpandedItems((prev) =>
                          expandedItems.includes(`${request.id}-${index}`)
                            ? [
                                ...prev.filter(
                                  (e) => e !== `${request.id}-${index}`
                                ),
                              ]
                            : [...prev, `${request.id}-${index}`]
                        )
                      }
                      style={{ cursor: "pointer", marginLeft: "auto" }}
                    >
                      <span
                        style={{
                          width: "100%",
                          minWidth: "80px",
                          textAlign: "center",
                          display: "inline-flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {request.status === "completed" ||
                        request.status === "playing" ? (
                          <span className="amount">
                            <CurrencyRupeeIcon />
                            {request.total_amount ? request.total_amount : 0}
                          </span>
                        ) : (
                          <span className="amount">{request.status}</span>
                        )}
                      </span>
                      {expandedItems.includes(`${request.id}-${index}`) ? (
                        <KeyboardArrowUp style={{ color: "white" }} />
                      ) : (
                        <KeyboardArrowDown style={{ color: "white" }} />
                      )}
                    </div>
                  )}
                </div>
                {(expandedItems.includes(`${request.id}-${index}`) ||
                  !isMobile) && (
                  <div className="details-row">
                    <span
                      style={{
                        color: "gray",
                        fontSize: "12px",
                        maxWidth: "150px",
                        textAlign: "left",
                        display: "inline-block",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        paddingLeft: "20px",
                      }}
                    >
                      ({request.host.id}) {request.host.name}
                    </span>
                    <span
                      style={{
                        color: "gray",
                        fontSize: "12px",
                        minWidth: "80px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "150px",
                      }}
                    >
                      {formatDate(
                        new Date(request.created_at),
                        " dd MMM yyyy, hh:mm a "
                      )}
                    </span>
                    {/* <span
                      style={{
                        color: "gray",
                        fontSize: "12px",
                        width: "100%",
                        minWidth: "80px",
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "80px",
                      }}
                    >
                      {formatDate(new Date(request.created_at), "dd MMM yyyy ")}
                    </span> */}
                    {!isMobile && (
                      <span
                        style={{
                          width: "100%",
                          minWidth: "80px",
                          textAlign: "center",
                          display: "inline-flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textTransform: "capitalize",
                          width: "80px",
                        }}
                      >
                        {request.status === "completed" ||
                        request.status === "playing" ? (
                          <span className="amount">
                            <CurrencyRupeeIcon />
                            {request.total_amount ? request.total_amount : 0}
                          </span>
                        ) : (
                          <span className="amount">{request.status}</span>
                        )}
                      </span>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div key={request.id} />
            )
          )}
        </InfiniteScroll>
        {/* {props.isLoading && (
          <div className="loadingContainer">
            <img
              src={searchingGif}
              alt="Searching Gif"
              style={{ width: "36px", height: "10px" }}
            />
          </div>
        )} */}
      </div>

      {!isPlayedScreen && (
        <div
          className="viewAll"
          onClick={() => {
            handleViewAllPlayed();
          }}
        >
          View all
        </div>
      )}
    </RecentlyPlayedWrapper>
  );
}

export default RecentRequest;
